module.exports = __webpack_public_path__ + "img/thumb-down-red.c008db83.svg";